import vtkStateBuilder from 'vtk.js/Sources/Widgets/Core/StateBuilder';
import Constants from 'vtk.js/Sources/Widgets/Widgets3D/LineWidget/Constants';

const { ShapeType } = Constants;

const handleShape = ShapeType.SPHERE;
const handleScale = 30;

export default function generateState(addedMeasurementCallback) {
    const state =
        vtkStateBuilder
        .createBuilder()
        .addStateFromMixin({
            labels: ['moveHandle'],
            mixins: ['origin', 'color', 'scale1', 'visible', 'manipulator', 'shape'],
            name: 'moveHandle',
            initialValues: {
                scale1: handleScale,
                visible: true,
                shape: handleShape
            },
        })
        .addStateFromMixin({
            labels: ['handle1'],
            mixins: ['origin', 'color', 'scale1', 'visible', 'manipulator', 'shape'],
            name: 'handle1',
            initialValues: {
                scale1: handleScale,
                visible: true,
                shape: handleShape
            },
        })
        .addStateFromMixin({
            labels: ['handle2'],
            mixins: ['origin', 'color', 'scale1', 'visible', 'manipulator', 'shape'],
            name: 'handle2',
            initialValues: {
                scale1: handleScale,
                visible: true,
                shape: handleShape
            },
        })
        .addStateFromMixin({
            labels: ['handle3'],
            mixins: ['origin', 'color', 'scale1', 'visible', 'manipulator', 'shape'],
            name: 'handle3',
            initialValues: {
                scale1: handleScale,
                visible: true,
                shape: handleShape
            },
        })
        .addStateFromMixin({
            labels: ['svgText'],
            mixins: ['origin', 'color', 'text', 'visible'],
            name: 'text',
            initialValues: {
                text: '',
            },
        })
        .addField({ name: 'lineThickness' })
        .addField({ name: 'unitConversionFactor', initialValue: 1.0 })
        .addField({ name: 'addedMeasurementCallback', initialValue: addedMeasurementCallback })
        .build();

    return state;
}
